import { ca } from '@cian/analytics';

/**
 * Требования для аналитики:
 * https://conf.cian.tech/pages/viewpage.action?pageId=1255737753
 */
export function trackAddOfferClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'mobile_main_page',
    action: 'click',
    label: 'add_adv',
  });
}
